import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { PageHeader } from "@/components/page-header";
import { StudentsCardsList } from "@/components/student/students-cards-list";
import { currentRole } from "@/lib/pb";
import { useDocumentTitle } from "@/lib/use-document-title";

const searchSchema = z
  .object({
    batch: z.string().optional(),
  })
  .passthrough();

export const Route = createFileRoute("/_app/students/")({
  // The batch roster is meaningless once students can only read their own
  // record — bounce them home. Teacher/support keep full access.
  beforeLoad: () => {
    if (currentRole() === "student") {
      throw redirect({ to: "/dashboard" });
    }
  },
  validateSearch: searchSchema,
  component: StudentsPage,
});

function StudentsPage() {
  useDocumentTitle("Students");
  const { batch } = Route.useSearch();
  return (
    <>
      <PageHeader eyebrow="Roster" title="Students" />
      <StudentsCardsList batchId={batch} />
    </>
  );
}
